import { BaseChart } from './components/base-chart';
import { LastUpdate } from './components/last-update';
import { RenderLastValue } from './components/render-last-value';
import { SeriesHidden } from './components/series-hidden';
import { CardChart } from './preset-charts/card-chart';
import { GroupChartBy } from './components/group-chart-by';
import { Benchmark } from './components/benchmarks';
import { ChartTabs } from './components/tabs';

export * from './create-series';
export * from './chart-options';
export * from './interface';
export * from './components/with-gross-up-reload-series';

export const Chart = {
  CardChart,
  SeriesHidden,
  Benchmark,
  LastUpdate,
  RenderLastValue,
  Chart: BaseChart,
  GroupChartBy,
  ChartTabs
};
